import "./SmsPanel.scss";
import SmsContent from "./SmsContent";
import SmsStatement from "./SmsStatement";
import {useSelector} from "react-redux";
import {useEffect, useState} from "react";
import _axios from "../../httpService";
import SMSTable from "./SMSTable";
import SMSMainText from "./SMSMainText";
import Loader from "../Loader";

const SmsPanel = () => {

    const [loader, setLoader] = useState(true);
    const sendData = useSelector(state => state.smsSlice);
    const initialData = useSelector(state => state.smsSliceInitial);
    console.log(sendData)

    useEffect(() => {
        _axios.get('https://jsonplaceholder.typicode.com/users/1')
            .then(res => {
                setLoader(false)
            })
    } , [])

    return (
        <div className="main-sms">
            {loader ? <Loader/> : <>
                <div className="sms-content">
                    <>
                        <SmsContent/>
                        <SMSMainText/>
                        <SmsStatement/>
                    </>
                </div>
                <SMSTable/>
            </>}
        </div>
    );
};
export default SmsPanel;
